import DataBinder from 'src/lib/data_binder';

function DateSchema(d) {
  if ('option_votes_count' in d) {
    this.text('.js-date-count', `${d.option_votes_count} / ${d.card_votes_count}`);
  }

  if ('remove' in d) {
    if (d.remove === 'null') { return; }
    const avatar = this.el.querySelector(`[data-item-assignee-id='${d.remove}']`);
    avatar && avatar.remove();
    const avatarVoter = this.el.querySelector(`[data-option-voter-id='${d.remove}']`);
    avatarVoter && avatarVoter.remove();
  }

  if ('option_avatars' in d) {
    this.html('.card-item-avatars', d.option_avatars);
  }
}

export default DataBinder.create(DateSchema);
